var _ellipse, _ellipse2, _ellipse3, _ellipse4, _line, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnComposeIfblock = function SvgIcnComposeIfblock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4994,
    cy: 5.84625,
    rx: 1.82142,
    ry: 1.84625,
    stroke: "currentcolor",
    strokeWidth: 1.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4994,
    cy: 18.1537,
    rx: 1.82142,
    ry: 1.84625,
    stroke: "currentcolor",
    strokeWidth: 1.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.1786,
    cy: 18.1537,
    rx: 1.82142,
    ry: 1.84625,
    stroke: "currentcolor",
    strokeWidth: 1.2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.82142,
    cy: 18.1537,
    rx: 1.82142,
    ry: 1.84625,
    stroke: "currentcolor",
    strokeWidth: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.4926,
    y1: 7.69276,
    x2: 12.4926,
    y2: 16.3086,
    stroke: "currentcolor",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1071 11.3849H7.82141C6.71684 11.3849 5.82141 12.2803 5.82141 13.3849V16.3082",
    stroke: "currentcolor",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8924 11.3849H17.1781C18.2827 11.3849 19.1781 12.2803 19.1781 13.3849V16.3082",
    stroke: "currentcolor",
    strokeWidth: 1.2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnComposeIfblock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_compose_ifblock.892a234c.svg";
export { ForwardRef as ReactComponent };